import login from './login';

if (IS_BROWSER) {
  window.registerSaga(login);
}
